// extracted by mini-css-extract-plugin
export default {"root":"RecycledProduct_root__jaerh"};